import actions from "./actions";
import state from "./states";
import mutations from "./mutations";

const AdminWeddingModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default AdminWeddingModule;